import { Component } from '@angular/core';
import { TextPipe } from '@ps20-frontend/text-service';

@Component({
  selector: 'ps20-shop-logoutpage',
  templateUrl: './logoutpage.component.html',
  imports: [TextPipe],
})
export class LogoutpageComponent {}
